import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Popover, { ArrowContainer } from 'react-tiny-popover';
import { localize } from 'core/localization';
import CircleLoader from 'components/common/CircleLoader';
import HotspotOnImageContentParser from './components/HotspotOnImageContentParser';
import {
  Wrapper,
  ImageSpotsWrapper,
  Image,
  Spots,
  PopoverInfoButton,
  PopoverContent
} from './HotspotOnImage.styled';

export class HotspotOnImage extends Component {
  constructor({ content }) {
    super();
    this.state = {
      content: HotspotOnImageContentParser(content) || '',
      isImageLoading: true
    };
  }

  getImageNaturalSizes = event => {
    this.setState({
      imageNaturalWidth: event.target.naturalWidth,
      imageNaturalHeight: event.target.naturalHeight,
      isImageLoading: false
    });
  };

  popoverOpenHandler = event => {
    let { id, classList } = event.target;
    this.setState({
      [id]: !this.state[id] || false
    });
    classList.toggle('active');
  };

  popoverCloseHandler = event => {
    let { id, classList } = event.target;
    this.setState({
      [id]: false
    });
    classList.remove('active');
  };

  handleOnKeyDown = event => {
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      this.popoverOpenHandler(event);
    }
  };

  render() {
    let data = this.state.content;
    let { image, spots } = data;
    let { imageNaturalWidth, imageNaturalHeight, isImageLoading } = this.state;

    return (
      <Wrapper isImageLoading={isImageLoading}>
        {image ? (
          <ImageSpotsWrapper>
            {isImageLoading ? <CircleLoader iconSize={18} /> : null}
            <Image
              src={image.src}
              alt={localize('[hotspot content image alt]')}
              onLoad={this.getImageNaturalSizes}
              style={isImageLoading ? { opacity: '0' } : null}
            />

            {spots && image && !isImageLoading
              ? spots.map(singleSpot => {
                  if (!singleSpot) {
                    return null;
                  }
                  let { id, text } = singleSpot.dataset;
                  let { width, height, left, top } = singleSpot.style;
                  let isOpenSingleSpot = this.state[id] || false;

                  return (
                    <Spots
                      key={id}
                      width={width}
                      height={height}
                      left={left}
                      top={top}
                      naturalWidth={imageNaturalWidth}
                      naturalHeight={imageNaturalHeight}
                    >
                      {isImageLoading ? null : (
                        <Popover
                          isOpen={isOpenSingleSpot}
                          position="left"
                          padding={9}
                          align="center"
                          transitionDuration={0.2}
                          containerStyle={{
                            zIndex: 10,
                            overflow: 'visible'
                          }}
                          content={({ position, targetRect, popoverRect }) => (
                            <ArrowContainer
                              position={position}
                              targetRect={targetRect}
                              popoverRect={popoverRect}
                              arrowColor={this.props.theme.colors.contentBodyColor}
                              arrowSize={6}
                            >
                              <PopoverContent id={`${id}-d`}>{text}</PopoverContent>
                            </ArrowContainer>
                          )}
                        >
                          <PopoverInfoButton
                            id={id}
                            tabIndex={1}
                            role="button"
                            aria-label={localize('[hotspot open popover]')}
                            onClick={this.popoverOpenHandler}
                            onKeyDown={this.handleOnKeyDown}
                            onBlur={this.popoverCloseHandler}
                            aria-describedby={`${id}-d`}
                          >
                            i
                          </PopoverInfoButton>
                        </Popover>
                      )}
                    </Spots>
                  );
                })
              : null}
          </ImageSpotsWrapper>
        ) : null}
      </Wrapper>
    );
  }
}

HotspotOnImage.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.object
};

export default withTheme(HotspotOnImage);
